import { useState } from "react";
import { vehicles } from "./data/vehicles";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import VehicleShowcase from "./components/VehicleShowcase";
import ArmorStandards from "./components/ArmorStandards";
import WhyChooseUs from "./components/WhyChooseUs";
import Contact from "./components/Contact";
import ContactCTA from "./components/ContactCTA";
import FloatingContact from "./components/FloatingContact";
import Footer from "./components/Footer";
import "./App.css";

const makes = [...new Set(vehicles.map((v) => v.brand))].sort();
const allModels = [...new Set(vehicles.map((v) => v.type))].sort();

function App() {
  const [selectedMakes, setSelectedMakes] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);

  const toggleMake = (make) => {
    setSelectedMakes((prev) =>
      prev.includes(make) ? prev.filter((m) => m !== make) : [...prev, make]
    );
  };

  const toggleModel = (model) => {
    setSelectedModels((prev) =>
      prev.includes(model) ? prev.filter((m) => m !== model) : [...prev, model]
    );
  };

  const selectAllMakes = (checked) => {
    setSelectedMakes(checked ? [...makes] : []);
  };

  const selectAllModels = (checked) => {
    setSelectedModels(checked ? [...allModels] : []);
  };

  return (
    <>
      <Header />
      <FloatingContact />
      <main>
        <Hero
          selectedMakes={selectedMakes}
          selectedModels={selectedModels}
          onToggleMake={toggleMake}
          onToggleModel={toggleModel}
          onSelectAllMakes={selectAllMakes}
          onSelectAllModels={selectAllModels}
        />
        <Services />
        <ContactCTA
          title="Ready to get started?"
          subtitle="Tell us about your requirements and we'll help you find the right armored vehicle."
        />
        <VehicleShowcase selectedMakes={selectedMakes} selectedModels={selectedModels} />
        <ArmorStandards />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
